if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
  // console.warn e console.error continuam funcionando
}
